export const TELEGRAM_DEFAULT_PHOTO_MIME_TYPE = 'image/jpeg';
export const TELEGRAM_DEFAULT_DOCUMENT_MIME_TYPE = 'application/octet-stream';
export const TELEGRAM_STRIPPED_PHOTO_SIZE = 40;
// https://core.telegram.org/bots/api#file
export const TELEGRAM_BOT_API_FILE_SIZE_LIMIT_20 = 1024 * 1024 * 20;
// https://core.telegram.org/bots/api#sendvideo
export const TELEGRAM_BOT_API_FILE_SIZE_LIMIT_50 = 1024 * 1024 * 50;
// https://core.telegram.org/bots/api#inputmediaphoto
export const TELEGRAM_CAPTION_LENGTH_LIMIT = 1024;
// https://core.telegram.org/bots/api#sendmessage
export const TELEGRAM_TEXT_LENGTH_LIMIT = 4096;
export const TME_BASE_URL = `https://t.me`;
export const TGSTAT_BASE_URL = `https://tgstat.ru`;
/*
All JavaScript numbers are IEEE-754 double-precision floating-point values.
That means:
Max safe integer: Number.MAX_SAFE_INTEGER = 9007199254740991 (≈ 9 × 10^15)
Min safe integer: Number.MIN_SAFE_INTEGER = -9007199254740991
*/
//https://core.telegram.org/api/bots/ids
const CHANNEL_ID_OFFSET = 1_000_000_000_000;
export const botApiChannelId = (clientChannelId) => String(-(CHANNEL_ID_OFFSET + Number.parseInt(clientChannelId)));
export const clientApiChannelId = (botApiChannelId) => String(-Number.parseInt(botApiChannelId) - CHANNEL_ID_OFFSET);
//# sourceMappingURL=telegram.js.map